<template>
    <EChart
        :options="chartOptions"
        card
        class="m-0"
        :header="$t('priceInTime')"
        :loading="requestPriceChart.getLoading()"
        type="time"
    >
        <template #nav>
            <div class="d-flex gap-3">
                <TimeRangeCalendar v-model="timeRange" />
                <ButtonIcon @click="fetchChartData()">{{ $t('loadData') }}</ButtonIcon>
            </div>
        </template>
    </EChart>
</template>



<script>
    import EChart from '@/components/common/EChart.vue';
    import TimeRangeCalendar from '@/components/common/TimeRangeCalendar.vue';

    export default {
        name: 'PriceChart',
        components: {
            EChart,
            TimeRangeCalendar,
        },
        data() {
            return {
                requestPriceChart: this.$req('offers/PriceChart'),
                id: Number.parseInt(this.$route.params.id),
                timeRange: null,
            };
        },
        computed: {
            chartOptions() {
                const reportData = this.requestPriceChart.getData()?.chart;
                if (!reportData || !reportData.length) {
                    return { series: [] };
                }
                const valueKeys = Object.keys(reportData[0]).filter(key => key !== 'date');
                const series = valueKeys.map(key => ({
                    name: key,
                    type: 'line',
                    data: reportData.map(item => [new Date(item.date).getTime(), item[key]]),
                    areaStyle: null,
                }));
                return {
                    legend: { data: valueKeys },
                    xAxis: {
                        boundaryGap: false,
                    },
                    yAxis: {
                        type: 'value',
                        name: this.$t('price'),
                        nameRotate: 90,
                        nameLocation: 'middle',
                    },
                    tooltip: {
                        valueFormatter: value => this.$format.currency(value),
                    },
                    series,
                };
            },
        },
        methods: {
            fetchChartData() {
                this.requestPriceChart.get({ urlParams: { offerId: this.id }, requestParams: { startDate: this.timeRange.startDate, endDate: this.timeRange.endDate }, cache: false });
            },
        },
    };
</script>
